module.exports = __webpack_public_path__ + "static/media/bg.1a793e0e.png";